import React from "react";
import documentUpload from "../../../../assets/home-document.png";
import IconVerified from "../../../../assets/verified.svg";
import IconUpload from "../../../../assets/upload.svg";
import { Link } from "react-router-dom";

export default function DokumenVerification() {
  return (
    <section className="psre-satu" style={{marginBottom: '60px'}}>
      <div className="container">
        <div className="row" style={{ marginTop: "76px" }}>
          <div className="col-md-6 d-none d-md-block" style={{paddingRight: '60px'}}>
            <img
              className="mb-0"
              src={documentUpload}
              alt="ilustrasi"
              style={{ width: "100%", objectFit: "contain" }}
            />
          </div>
          <div className="col-sm-12 col-12 col-md-6 pl-0" style={{marginTop: "0px"}}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: '16px'
              }}
            >
              <img
                className="mb-0"
                src={IconVerified}
                alt="icon-verified"
                style={{ width: "15px", objectFit: "contain" }}
              />
              <p
                style={{
                  marginBottom: "0px",
                  color: "#1672BD",
                  marginLeft: "10px",
                }}
                className="p-nunito"
              >
                Verifikasi Dokumen
              </p>
            </div>
            <div>
              <h1 className="h1-nunito">
                Verifikasi Dokumen Dengan Fitur{" "}
                <span style={{ color: "#1672BD" }}>PDFsign</span>
              </h1>
            </div>
            <p
              style={{ margin: "22px 0px", maxWidth: "440px" }}
              className="p-nunito"
            >
              Lakukan verifikasi keaslian dokumen elektronik PDF yang sah dan
              telah memiliki TTE dengan unggah file pada tombol dibawah ini.
            </p>
            <Link
              style={{
                backgroundColor: "#1672BD",
                color: "white",
                border: "1px solid #1672BD",
                cursor: "pointer",
                width: "205px",
                display: 'flex', 
                flexDirection: "row",
                alignItems: 'center',
              }}
              to="/verifyPDF"
              className="nav-link btn p-nunito btn-instance"
            >
              <img
                className="mb-0"
                src={IconUpload}
                alt="icon-upload"
                style={{ width: "24px", objectFit: "contain",marginRight: '5px' }}
              />
              <p style={{marginBottom: '0px', color: 'white'}} className="p-nunito">Upload File PDF Anda</p>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
